
  import createMeisterIcons from '../src/createMeisterIcons';

  const FlagTriangle = createMeisterIcons("flag-triangle", [["path",{"fill":"currentColor","d":"M7.68 5.238v8.8l8.481-3.98zm0 10.458v4.223a.75.75 0 0 1-1.5 0V4.32c0-.362.188-.682.477-.855.247-.148.66-.218 1 .035l9.452 5.373.007.004c.482.289.73.774.7 1.275a1.37 1.37 0 0 1-.75 1.14l-.008.003z","key":"bc62337739ab8f11c7fa503280ee0ec505755b48","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default FlagTriangle
  